




// import React, { useState, useEffect } from 'react';
// import { FaLocationPin } from 'react-icons/fa6';
// import { Link } from 'react-router-dom';
// import { statesAndLgas } from '../../stateAndLga';

// const SearchByLocation = () => {
//   const [stateJobs, setStateJobs] = useState({});
//   const [selectedState, setSelectedState] = useState('');
//   const [selectedLGA, setSelectedLGA] = useState('');
//   const [filteredJobs, setFilteredJobs] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob2?page=1&limit=100`);
//         const data = await response.json();
//         if (Array.isArray(data)) {
//           const groupedByState = data.reduce((acc, job) => {
//             const state = job.state.toLowerCase();
//             acc[state] = acc[state] || [];
//             acc[state].push(job);
//             return acc;
//           }, {});
//           setStateJobs(groupedByState);
//           setFilteredJobs(groupedByState); // Initialize filtered jobs with all data
//         }
//       } catch (error) {
//         console.error("Error fetching jobs:", error);
//       }
//     };
//     fetchJobs();
//   }, []);

//   const handleStateChange = (e) => {
//     const state = e.target.value.toLowerCase();
//     setSelectedState(state);
//     setSelectedLGA(''); // Reset LGA when state changes
//     if (!state) {
//       setFilteredJobs(stateJobs);
//     } else {
//       const filtered = { [state]: stateJobs[state] || [] };
//       if (selectedLGA) {
//         filtered[state] = (stateJobs[state] || []).filter(job =>
//           job.localGovernment.toLowerCase() === selectedLGA.toLowerCase()
//         );
//       }
//       setFilteredJobs(filtered);
//     }
//   };

//   const handleLGAChange = (e) => {
//     const lga = e.target.value.toLowerCase();
//     setSelectedLGA(lga);
//     if (selectedState && lga) {
//       const filtered = {
//         [selectedState]: (stateJobs[selectedState] || []).filter(job =>
//           job.localGovernment.toLowerCase() === lga
//         )
//       };
//       setFilteredJobs(filtered);
//     } else if (!lga && selectedState) {
//       setFilteredJobs({ [selectedState]: stateJobs[selectedState] || [] });
//     }
//   };

//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   return (
//     <div>
//       <div className="flex flex-row items-center justify-center pl-4 md:pl-20">
//         <h1 className="text-2xl font-extrabold text-center uppercase mb-4 text-gray-900">
//           Jobs By Location
//         </h1>
//         {/* <div className="p-2 w-fit rounded-full text-orange-500 text-xl ml-1">
//             <FaLocationPin />
//         </div> */}
//       </div>
//       <div className="mb-4 text-center flex flex-col sm:flex-row justify-center items-center gap-2">
//         <select
//           value={selectedState}
//           onChange={handleStateChange}
//           className="p-2 border border-gray-300 rounded-md w-full sm:w-auto"
//         >
//           <option value="">Select State</option>
//           {Object.keys(statesAndLgas).map(state => (
//             <option key={state} value={state.toLowerCase()}>{state}</option>
//           ))}
//         </select>
//         <select
//           value={selectedLGA}
//           onChange={handleLGAChange}
//           className="p-2 border border-gray-300 rounded-md w-full sm:w-auto"
//           disabled={!selectedState}
//         >
//           <option value="">Select LGA (optional)</option>
//           {selectedState && statesAndLgas[selectedState.toUpperCase()]?.map(lga => (
//             <option key={lga} value={lga.toLowerCase()}>{lga}</option>
//           ))}
//         </select>
//       </div>
//       <ul className="grid grid-cols-3 gap-2 sm:flex sm:flex-wrap sm:justify-center sm:gap-8">
//         {Object.keys(filteredJobs).slice(0, 5).map((state, index) => (
//           <li className="px-2 py-2 border-2 w-full sm:w-[200px]" key={index}>
//             <div className="p-2 w-fit border-2 border-slate-300 rounded-full text-orange-500 text-xl">
//               {/* <FaLocationPin /> */}
//             </div>
//             <Link
//               className="text-lg capitalize text-gray-800 hover:text-indigo-600 font-medium transition-colors"
//               to={`/jobs/?state=${state}`}
//             >
//               {state}
//             </Link>
//             <div className="text-sm text-gray-500">vacancy {filteredJobs[state]?.length || 0}</div>
//           </li>
//         ))}
//       </ul>
//       {Object.keys(filteredJobs).length > 5 && (
//         <div className="text-center mt-4">
//           <button
//             onClick={toggleModal}
//             className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
//           >
//             See More
//           </button>
//         </div>
//       )}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto">
//             <h2 className="text-2xl font-bold mb-4 text-gray-900">All Locations</h2>
//             <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//               {Object.keys(filteredJobs).map((state, index) => (
//                 <li className="px-2 py-2 border-2 w-full" key={index}>
//                   <div className="p-2 w-fit border-2 border-slate-300 rounded-full text-orange-500 text-xl">
//                     {/* <FaLocationPin /> */}
//                   </div>
//                   <Link
//                     className="text-lg capitalize text-gray-800 hover:text-indigo-600 font-medium transition-colors"
//                     to={`/jobs/?state=${state}`}
//                     onClick={toggleModal}
//                   >
//                     {state}
//                   </Link>
//                   <div className="text-sm text-gray-500">vacancy {filteredJobs[state]?.length || 0}</div>
//                 </li>
//               ))}
//             </ul>
//             <div className="text-center mt-4">
//               <button
//                 onClick={toggleModal}
//                 className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchByLocation;

















import React, { useState, useEffect } from 'react';
import { FaLocationPin } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { statesAndLgas } from '../../stateAndLga';

const SearchByLocation = () => {
  const [stateJobs, setStateJobs] = useState({});
  const [selectedState, setSelectedState] = useState('');
  const [selectedLGA, setSelectedLGA] = useState('');
  const [filteredJobs, setFilteredJobs] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}job/alljob?page=1&limit=100`);
        const data = await response.json();
        if (Array.isArray(data)) {
          const groupedByState = data.reduce((acc, job) => {
            const state = job.state.toLowerCase();
            acc[state] = acc[state] || [];
            acc[state].push(job);
            return acc;
          }, {});
          setStateJobs(groupedByState);
          setFilteredJobs(groupedByState);
        }
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    fetchJobs();
  }, []);

  // When state is selected → filter jobs
  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setSelectedLGA(''); // Reset LGA

    if (!state) {
      setFilteredJobs(stateJobs);
    } else {
      const lowerState = state.toLowerCase();
      const filtered = { [lowerState]: stateJobs[lowerState] || [] };
      setFilteredJobs(filtered);
    }
  };

  // When LGA is selected → filter further
  const handleLGAChange = (e) => {
    const lga = e.target.value;
    setSelectedLGA(lga);

    if (!lga) {
      const lowerState = selectedState.toLowerCase();
      setFilteredJobs({ [lowerState]: stateJobs[lowerState] || [] });
    } else {
      const lowerState = selectedState.toLowerCase();
      const filtered = {
        [lowerState]: (stateJobs[lowerState] || []).filter(job =>
          job.localGovernment.toLowerCase() === lga.toLowerCase()
        )
      };
      setFilteredJobs(filtered);
    }
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  // Get LGAs for selected state
  const getLGAs = () => {
    if (!selectedState) return [];
    const stateKey = Object.keys(statesAndLgas).find(
      key => key.toLowerCase() === selectedState.toLowerCase()
    );
    return stateKey ? statesAndLgas[stateKey] : [];
  };

  return (
    <div>
      <div className="flex flex-row items-center justify-center pl-4 md:pl-20">
        <h1 className="text-2xl font-extrabold text-center uppercase mb-4 text-gray-900">
          Jobs By Location
        </h1>
      </div>

      {/* STATE & LGA SELECT — NOW WORKING PERFECTLY */}
      <div className="mb-6 text-center flex flex-col sm:flex-row justify-center items-center gap-4">
        <select
          value={selectedState}
          onChange={handleStateChange}
          className="p-3 border border-gray-300 rounded-lg w-full sm:w-64 text-base focus:border-purple-500 focus:outline-none"
        >
          <option value="">All States</option>
          {Object.keys(statesAndLgas).map(state => (
            <option key={state} value={state}>
              {state}
            </option>
          ))}
        </select>

        {/* LGA DROPDOWN — ONLY SHOWS WHEN STATE IS SELECTED */}
        <select
          value={selectedLGA}
          onChange={handleLGAChange}
          disabled={!selectedState}
          className="p-3 border border-gray-300 rounded-lg w-full sm:w-64 text-base focus:border-purple-500 focus:outline-none disabled:bg-gray-100"
        >
          <option value="">All LGAs</option>
          {getLGAs().map(lga => (
            <option key={lga} value={lga}>
              {lga}
            </option>
          ))}
        </select>
      </div>

      {/* Job Count by State */}
      <ul className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
        {Object.keys(filteredJobs).slice(0, 10).map((state, index) => (
          <li key={index} className="bg-white border-2 border-gray-200 rounded-xl p-5 text-center hover:shadow-lg hover:border-purple-400 transition">
            <div className="flex justify-center mb-3">
              <div className="p-3 bg-purple-100 rounded-full">
                <FaLocationPin className="w-6 h-6 text-purple-600" />
              </div>
            </div>
            <Link
              to={`/jobs/?state=${state}`}
              className="block text-base font-semibold text-gray-800 hover:text-purple-600 capitalize"
            >
              {state}
            </Link>
            <p className="text-sm text-gray-600 mt-2">
              {filteredJobs[state]?.length || 0} job{filteredJobs[state]?.length !== 1 ? "s" : ""}
            </p>
          </li>
        ))}
      </ul>

      {Object.keys(filteredJobs).length > 10 && (
        <div className="text-center mt-8">
          <button
            onClick={toggleModal}
            className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition"
          >
            See All Locations
          </button>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-screen overflow-y-auto p-8">
            <h2 className="text-2xl font-bold text-center mb-6">All Locations</h2>
            <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {Object.keys(filteredJobs).map((state, index) => (
                <li key={index} className="bg-gray-50 border rounded-xl p-5 text-center hover:bg-gray-100 transition">
                  <Link
                    to={`/jobs/?state=${state}`}
                    onClick={toggleModal}
                    className="block font-semibold text-gray-800 hover:text-purple-600 capitalize"
                  >
                    {state}
                  </Link>
                  <p className="text-sm text-gray-600 mt-2">
                    {filteredJobs[state]?.length || 0} job{filteredJobs[state]?.length !== 1 ? "s" : ""}
                  </p>
                </li>
              ))}
            </ul>
            <div className="text-center mt-8">
              <button
                onClick={toggleModal}
                className="px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchByLocation;